import { Tooltip } from "antd";

export const ProductTags = ({ products, padding = "5px 8px" }) => {
  const visibleProducts = products.slice(0, 2);
  const hiddenProducts = products.slice(2);

  return (
    <div
      style={{
        display: "flex",
        gap: "5px",
        flexWrap: "nowrap",       // prevent line break
        overflow: "hidden",       // clip content if needed
      }}
    >
      {visibleProducts.map((product, index) => (
        <div
        className="productTagsStyle"
          key={index}
          className="productTagsStyle"
          style={{
            backgroundColor: "#5E5E5E",
            color: "white",
            padding: padding,
            borderRadius: "4px",
            fontSize: "10px",
            fontWeight: "600",
            whiteSpace: "nowrap",  // prevent individual tag wrap
          }}
        >
           <Tooltip title={product}>
          <span
            style={{
              backgroundColor: "#5E5E5E",
              color: "white",
              padding: padding,
              borderRadius: "4px",
              fontSize: "10px",
              fontWeight: "600",
              cursor: "pointer",
              whiteSpace: "nowrap", // prevent wrap on "+N"
            }}
          >
          {product}</span>
          </Tooltip>
        </div>
      ))}
      {hiddenProducts.length > 0 && (
        <Tooltip title={hiddenProducts.join(", ")}>
          <span
            style={{
              backgroundColor: "#5E5E5E",
              color: "white",
              padding: padding,
              borderRadius: "4px",
              fontSize: "10px",
              fontWeight: "600",
              cursor: "pointer",
              whiteSpace: "nowrap", // prevent wrap on "+N"
            }}
          >
            +{hiddenProducts.length}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

